import { BasicButton } from "thrive-components"
import { AllContentSVG } from "./contentSVGs"

const AllAvailableContentAsSource = ({onButtonClick}: {onButtonClick:()=>void}) => {
    return (
        <div className="all-available-content-as-source">
            <AllContentSVG />

            <span className="available-content">All Available Content</span>
            
            <span className="available-content-explainer">Each user will see all content they have access to, including new content as it’s published.</span>
            
            <BasicButton 
                className="reset-sources-button"
                content={"Change sources"} 
                ariaLabel={"Change your Source List Selection"}
                onButtonClick={onButtonClick}
            />
        </div>
    )
}

export default AllAvailableContentAsSource